import { API_BASE_URL } from "@/config";
import { createRouter, createWebHistory } from "vue-router";
import OnboardingIndex from "@/layouts/public_layout/OnboardingIndex.vue";
import UserLogin from "@/layouts/public_layout/onboarding/login/UserLogin.vue";
import FirstTimePasswordReset from "@/layouts/public_layout/onboarding/first_time_password_reset/FirstTimePasswordReset.vue";
import InvalidLink from "@/layouts/public_layout/onboarding/invalid_link/InvalidLink.vue";
import InvalidToken from "@/layouts/public_layout/onboarding/invalid_token/InvalidToken.vue";
import DeactiveAsset from "@/layouts/public_layout/onboarding/deactive_asset/DeactiveAsset.vue";
import SubWorkflowPage from "@/layouts/public_layout/sub_worlflow_page/SubWorkflowPage.vue";
import UserOtp from "@/layouts/public_layout/onboarding/otp/UserOtp.vue";
import UserRegistration from "@/layouts/public_layout/onboarding/registration/UserRegistration.vue";
import IdVerification from "@/layouts/public_layout/onboarding/id_verification/IdVerification.vue";
import FacialBiometrics from "@/layouts/public_layout/onboarding/facial_biometrics/FacialBiometrics.vue";
import CompanyVerification from "@/layouts/public_layout/onboarding/company_verification/CompanyVerification.vue";
import CompanyPending from "@/layouts/public_layout/onboarding/company_pending/CompanyPending.vue";
import ClientDashboard from "@/layouts/client/client_dashboard/ClientDashboard.vue";
import WorkflowManagementComponent from "@/layouts/client/workflow_management/WorkflowManagementComponent.vue";
import ViewWorkflow from "@/layouts/client/view_workflow/ViewWorkflow.vue";
import ClientServices from "@/layouts/client/client_services/ClientServices.vue";
import ArrangeWorkflow from "@/layouts/client/arrange_workflow/ArrangeWorkflow.vue";
import ReasonsForUsage from "@/layouts/client/reasons_for_usage/ReasonsForUsage.vue";
import UploadConsent from "@/layouts/client/upload_consent/UploadConsent.vue";
import ConfirmWorkflow from "@/layouts/client/confirm_workflow/ConfirmWorkflow.vue";
import WorkflowDashboard from "@/layouts/client/workflow_dashboard/WorkflowDashboard.vue";
import CustomerIndex from "@/layouts/customer/CustomerIndex.vue";
import FacialBiometricsVerification   from "@/layouts/credit_bureau_services/facial_biometrics_verification/FacialBiometricsVerification.vue";
import CreditReport from "@/layouts/credit_bureau_services/credit_report/CreditReport.vue";
import IncomeEstimator from "@/layouts/credit_bureau_services/income_estimator/IncomeEstimator.vue";
import IncomePredictor from "@/layouts/credit_bureau_services/income_predictor/IncomePredictor.vue";
import CustomerDashboard from "@/layouts/customer/customer_dashboard/CustomerDashboard.vue";
import AssignedWorkflows from "@/layouts/customer/workflows/AssignedWorkflows.vue";
import CustomerConsent from "@/layouts/customer/customer_consent/CustomerConsent.vue";
import ThankYouPage from "@/layouts/public_layout/thank_you_page/ThankYouPage.vue";
import ThankYouAnonymous from "@/layouts/public_layout/thank_you_anonymous/ThankYouAnonymous.vue";
import ViewCustomers from "@/layouts/client/view_customers/ViewCustomers.vue";
import ProjectTable from "@/layouts/client/project_table/ProjectTable.vue";
import ProjectDashboard from "@/layouts/client/project_dashboard/ProjectDashboard.vue";
import WorkflowTemplates from '@/layouts/client/WorkFlowTemplate/WorflowTemplates.vue';
import BehalfApplication from "@/layouts/client/behalf_application/BehalfApplication.vue";
import BatchProcessing from "@/layouts/client/batch_processing/BatchProcessing.vue";
import ViewBatches from "@/layouts/client/view_batches/ViewBatches.vue";
import ServiceDashboard from "@/layouts/client/service_dashboard/ServiceDashboard.vue";
import WorkflowServices from "@/layouts/client/workflow_services/WorkflowServices.vue";
import ServiceRules from "@/layouts/client/service_rules/ServiceRules.vue";
import RegisterQuestionSelection from "@/layouts/client/register_question_selection/RegisterQuestionSelection.vue";
import ViewService from "@/layouts/client/view_service/ViewService.vue";
import AdminComponents from "@/layouts/admin/admin_components/AdminComponents.vue";
import AdminDashboard from "@/layouts/admin/admin_dashboard/AdminDashboard.vue";
import ClientApplications from "@/layouts/admin/client_applications/ClientApplications.vue";

import ViewSingleWorkflow from "@/layouts/admin/view_workflows/view_single_workflow/ViewSingleWorkflow.vue";
import ViewWorkflowStatus from "@/layouts/admin/view_workflows/view_workflow_status/ViewWorkflowStatus.vue";

import SystemUsers from "@/layouts/admin/system_users/SystemUsers.vue";
import ViewAssets from "@/layouts/admin/view_assets/ViewAssets.vue";
import ViewSingleAsset from "@/layouts/admin/view_asset/ViewSingleAsset.vue";
import ViewAdmin from "@/layouts/admin/view_admin/ViewAdmin.vue";
import ViewClient from "@/layouts/admin/view_client/ViewClient.vue";
import ViewPendingApplication from "@/layouts/admin/view_pending_application/ViewPendingApplication.vue";
import ViewApprovedApplication from "@/layouts/admin/view_approved_application/ViewApprovedApplication.vue";
import ViewDeclinedApplication from "@/layouts/admin/view_declined_application/ViewDeclinedApplication.vue";
import ViewDeactivatedApplication from "@/layouts/admin/view_deactivated_application/ViewDeactivatedApplication.vue";
import ViewCustomer from "@/layouts/admin/view_customer/ViewCustomer.vue";
import ViewClientAdmin from "@/layouts/admin/view_client_admin/ViewClientAdmin.vue";
import QuestionManagement from "@/layouts/client/question_management/QuestionManagement.vue";
import FormManagement from "@/layouts/client/form_management/FormManagement.vue";
import ManageForm from "@/layouts/client/manage_form/ManageForm.vue";
import TemplateManagement from "@/layouts/client/template_management/TemplateManagement.vue";
import TemplateConfiguration from "@/layouts/client/template_configuration/TemplateConfiguration.vue";
import InstantVerify from "@/layouts/client/view_instant_services/InstantServices.vue";
import ServiceExtracts from "@/layouts/client/service_extracts/ServiceExtracts.vue";
import ServiceApplications from "@/layouts/admin/service_applications/ServiceApplications.vue";
import InstantServices from "@/layouts/client/view_instant_services/InstantServices.vue";
import YourServices from "@/layouts/client/services/YourServices.vue";
import CustomerProfile from "@/layouts/customer/customer_profile/CustomerProfile.vue";
import AntiMoneyLaundering from "@/layouts/services/anti_money_laundering/AntiMoneyLaundering.vue";
import ServiceIndex from "@/layouts/services/ServiceIndex.vue";
import RefugeeVerification from "@/layouts/services/refugee_verification/RefugeeVerification.vue";
import RefugeeVerificationService from "@/layouts/credit_bureau_services/refugee_verification_service/RefugeeVerificationService.vue";
import VerifyLogs from "@/layouts/client/verify_logs/VerifyLogs.vue";
import ViewLogs from "@/layouts/admin/view_logs/ViewLogs.vue";
import ClientRequestedServices from "@/layouts/admin/client_requested_services/ClientRequestedServices.vue";
import ClientAdmin from "@/layouts/client/client_admin/ClientAdminUsers.vue";
import CIPCVerification from "@/layouts/credit_bureau_services/cipc_verification/CIPCVerification.vue";
import CustomService from "@/layouts/credit_bureau_services/custom_service/CustomService.vue";
import AMLVerification from "@/layouts/credit_bureau_services/aml_verification/AMLVerification.vue";
import EnterpriseAMLVerification from "@/layouts/credit_bureau_services/enterprise_aml_verification/EnterpriseAMLVerification.vue";
import EnterpriseTransUnionCreditVerification from "@/layouts/credit_bureau_services/enterprise_transunion_credit_verification/EnterpriseTransUnionCreditVerification.vue";
import EnterpriseTransUnionKYBVerification from "@/layouts/credit_bureau_services/enterprise_transunion_kyb_verification/EnterpriseTransUnionKYBVerification.vue";
import CustomerData from "@/layouts/client/customer_data/CustomerData.vue";
import CustomerApplications from "@/layouts/client/customer_applications/CustomerApplications.vue";
import CreateAsset from "@/layouts/client/create_asset/CreateAsset.vue";
import QuestionBasedAuthentication from "@/layouts/credit_bureau_services/question_based_authentication/QuestionBasedAuthentication.vue";
import ViewAsset from "@/layouts/client/view_asset/ViewAsset.vue";
import CompanyVerificationPdf from "@/layouts/services/company_verification_pdf/CompanyVerificationPdf.vue";
import RsaIdLivenessVerification from "@/layouts/credit_bureau_services/rsa_id_liveness_verification/RsaIdLivenessVerification.vue";
import RefugeeLivenessVerification from "@/layouts/credit_bureau_services/refugee_liveness_verification/RefugeeLivenessVerification.vue";
import SearchFcra from "@/layouts/credit_bureau_services/search_fcra/SearchFcra.vue";
import ProofOfIncomeManual from "@/layouts/credit_bureau_services/proof_of_income_manual/ProofOfIncomeManual.vue";
import ProofOfIncomeOnline from "@/layouts/credit_bureau_services/proof_of_income_online/ProofOfIncomeOnline.vue";
import EligibilityService from "@/layouts/credit_bureau_services/eligibility_service/EligibilityService.vue";
import FacialLivenessCheckVerification from "@/layouts/credit_bureau_services/facial_liveness_verification/FacialLivenessCheckVerification.vue";
import OcrVerification from "@/layouts/credit_bureau_services/ocr_verification/OcrVerification.vue";
import DirectorInfo from "@/layouts/customer/director_info/DirectorInfo.vue";
import UploadProofOfAddress from "@/layouts/public_layout/onboarding/upload_proof_of_address/UploadProofOfAddress.vue";
import DirectorConsent from "@/layouts/public_layout/onboarding/director_consent/DirectorConsent.vue";
import BankAccountVerification from "@/layouts/credit_bureau_services/bank_account_verification/BankAccountVerification.vue";
import BankAccountIndividualVerification from "@/layouts/credit_bureau_services/bank_account_individual_verification/BankAccountIndividualVerification.vue";
import QualificationCheck from "@/layouts/services/qualification_check/QualificationCheck.vue";
import AfisCriminalCheck from "@/layouts/services/afis_criminal_check/AfisCriminalCheck.vue";

import DynamicLandingPage from "@/layouts/public_layout/dynamic_landing_page/DynamicLandingPage.vue";
import QualCheck from "@/layouts/credit_bureau_services/qual_check/QualCheck.vue";
import AfisCrimCheck from "@/layouts/credit_bureau_services/afis_crim_check/AfisCrimCheck.vue";
import ConditionalQuestions from "@/layouts/client/conditional_questions/ConditionalQuestions.vue";
import ServiceUtilize from "@/layouts/client/services/service_utilize/ServiceUtilize.vue";
import SystemCommunications from "@/layouts/client/system_communications/SystemCommunications.vue";

import AddressMatch from "@/layouts/services/address_match/AddressMatch.vue";
import RsaIdVerify from "@/layouts/services/rsa_id_verify/RsaIdVerify.vue";
import AddressMatchVerification from "@/layouts/credit_bureau_services/address_match_verification/AddressMatchVerification.vue";
import AcademicPost92CheckVerification from "@/layouts/credit_bureau_services/academic_post_92_check_verification/AcademicPost92CheckVerification.vue";

import ExperianCreditReport from "@/layouts/credit_bureau_services/experian_credit_report/ExperianCreditReport.vue";

import ServiceManagement from "@/layouts/service_management/ServiceManagement.vue";
import ClientServicesManagement from "@/layouts/service_management/client_services_management/ClientServicesManagement.vue";
import ClientService from "@/layouts/service_management/client_service/ClientService.vue";
import ServiceUtil from "@/layouts/service_management/service_util/ServiceUtil.vue";

import SubWorkflow from "@/layouts/client/sub_workflows/SubWorkflow.vue";
import ClientThankYou from "@/layouts/client/thank_you/ThankYou.vue";
import ThankYouConfiguration from "@/layouts/client/thank_you_configuration/ThankYouConfiguration.vue";
import OnlineBankStatement from "@/layouts/credit_bureau_services/finch_online_bankstatement/OnlineBankStatement.vue";
import CompleteOnlineBankStatement from "@/layouts/credit_bureau_services/finch_online_bankstatement/complete/CompleteOnlineBankStatement.vue";

import ManualBankStatement from "@/layouts/credit_bureau_services/finch_manual_bankstatement/ManualBankStatement.vue";
import ViewWorkflowClients from "@/layouts/admin/view_workflows/view_workflow_clients/ViewWorkflowClients.vue";
import AddressDetails from "@/layouts/credit_bureau_services/seriti_forms/address_details/AddressDetails.vue";
import MaritalInformation from "@/layouts/credit_bureau_services/seriti_forms/marital_information/MaritalInformation.vue";
import PersonalDetails from "@/layouts/credit_bureau_services/seriti_forms/personal_details/PersonalDetails.vue";
import SalaryDetails from "@/layouts/credit_bureau_services/seriti_forms/salary_details/SalaryDetails.vue";
import EmploymentDetails from "@/layouts/credit_bureau_services/seriti_forms/employment_details/EmploymentDetails.vue";
import QualifyingCriteria from "@/layouts/credit_bureau_services/seriti_forms/qualifying_criteria/QualifyingCriteria.vue";

import SeritiFinanceApplication from "@/layouts/credit_bureau_services/seriti_forms/seriti_finance_application/SeritiFinanceApplication.vue";

import TrustNameSearch from "@/layouts/credit_bureau_services/trust_name_search/TrustNameSearch.vue";
import TrustTrusteeSearch from "@/layouts/credit_bureau_services/trust_trustees_search/TrustTrusteesSearch.vue";
import SygnioQuestions from "@/layouts/sygnio/client_onboarding/sygnio_questions/SygnioQuestions.vue";
import OnBehalfOnboarding from "@/layouts/public_layout/on_behalf_onboarding/OnBehalfOnboarding.vue";

import AlternativeLivenessVerification from "@/layouts/credit_bureau_services/alternative_liveness_verification/AlternativeLivenessVerification.vue";
import OcrLivenessVerification from "@/layouts/credit_bureau_services/ocr_liveness_verification/OcrLivenessVerification.vue";
import RsaIdVerification from "@/layouts/credit_bureau_services/rsa_id_verification/RsaIdVerification.vue";
import ComprehensiveLivenessVerification from "@/layouts/credit_bureau_services/comprehensive_liveness_verification/ComprehensiveLivenessVerification.vue";

import AllInOneBankStatementVerification from "@/layouts/credit_bureau_services/all_in_one_bank_statement_verification/AllInOneBankStatementVerification.vue";
import AllInOneComplete from "@/layouts/credit_bureau_services/all_in_one_bank_statement_verification/complete/CompleteOnlineBankStatement.vue";

import WorkflowNotifications from "@/layouts/admin/view_workflows/workflow_notifications/WorkflowNotifications.vue";

import EmployeeScreeningService from "@/layouts/credit_bureau_services/employee_screening_service/EmployeeScreeningService.vue";
import MastercardMatchInquiry from "@/layouts/credit_bureau_services/mastercard_match_inquiry/MastercardMatchInquiry.vue";
import TrustDataFetch from "@/layouts/credit_bureau_services/trust_data_fetch/TrustDataFetch.vue";

import IndividualLivenessVerification from "@/layouts/credit_bureau_services/individual_liveness_verification/IndividualLivenessVerification.vue";
import HuruCriminalCheckVerification from "@/layouts/credit_bureau_services/huru_criminal_check_verification/HuruCriminalCheckVerification.vue";

import DataHub from "@/layouts/data_hub/DataHub.vue";
import ClientAdmins from "@/layouts/data_hub/components/client_admins/ClientAdmins.vue";
import SelectServices from "@/layouts/client/select_services/SelectServices.vue";
import ToolBox from "@/layouts/client/toolbox/ToolBox.vue";
import CompanyVerificationAndScore from "@/layouts/credit_bureau_services/company_verification_and_score/CompanyVerificationAndScore.vue";
import WorkbenchComponent from "@/layouts/client/workbench/WorkbenchComponent.vue";
import NotesPage from "@/layouts/notes/NotesPage.vue";
import CreditReportNamibia from "@/layouts/credit_bureau_services/credit_report_namibia/CreditReportNamibia.vue";
import TelephoneList from "@/layouts/credit_bureau_services/telephones/Telephones.vue";

const routes = [
  {
    path: "/",
    name: "OnboardingIndex",
    component: OnboardingIndex,
    children: [
      {
        path: "",
        name: "user_login",
        component: UserLogin,
      },
      {
        path: "first_time_password_reset",
        name: "first_time_password_reset",
        component: FirstTimePasswordReset,
      },
      {
        path: "invalid_link",
        name: "invalid_link",
        component: InvalidLink,
      },
      {
        path: "invalid_token",
        name: "invalid_token",
        component: InvalidToken,
      },

      {
        path: "asset_deactive",
        name: "asset_deactive",
        component: DeactiveAsset,
      },
      {
        path: "user_otp",
        name: "user_otp",
        component: UserOtp,
        meta: { requiresAuth: true },
      },
      {
        path: "user_registration",
        name: "user_registration",
        component: UserRegistration,
      },
      {
        path: "id_verification",
        name: "id_verification",
        component: IdVerification,
        meta: { requiresAuth: true },
      },
      {
        path: "facial_biometrics",
        name: "facial_biometrics",
        component: FacialBiometrics,
        meta: { requiresAuth: true },
      },
      {
        path: "company_verification",
        name: "company_verification",
        component: CompanyVerification,
        meta: { requiresAuth: true },
      },
      {
        path: "company_pending",
        name: "company_pending",
        component: CompanyPending,
        meta: { requiresAuth: true },
      },
      {
        path: "director_consent",
        name: "director_consent",
        component: DirectorConsent,
      },
    ],
  },
  {
    path: "/system_admin",
    component: AdminComponents,
    children: [
      {
        path:  "view_workflow/",
        name: "admin_view_workflow",
        component: ViewWorkflow,
        props: true,
      },
      {
        path: "admin_dashboard",
        name:  "admin_dashboard",
        component: AdminDashboard,
      },
      {
        path:  "service_mangement",
        name:  "service_mangement",
        component: ServiceManagement,
      },
      {
        path:  "client_service_management/:client_id/:service_id/",
        name:  "client_service_management",
        component: ClientService,
      },
      {
        path:  "client_services_management/:client_id/",
        name:  "client_services_management",
        component: ClientServicesManagement,
      },
      {
        path:  "service_util_management/:service_id/",
        name:  "service_util_mangement",
        component: ServiceUtil,
      },

      {
        path:  "client_applications",
        name:  "client_applications",
        component: ClientApplications,
      },
      {
        path:  "view_workflow_status",
        name:  "view_workflow_status",
        component: ViewWorkflowStatus,
      },
      {
        path: "view_workflow_clients/:workflow_id",
        name:  "view_workflow_clients",
        component: ViewWorkflowClients,
      },
      {
        path: "view_customer_applications/:id",
        name: "view_customer_applications",
        component: CustomerApplications,
      },
      {
        path:  "view_single_workflow/:workflow_id",
        name:  "view_single_workflow",
        component: ViewSingleWorkflow,
      },
      {
        path:  "users",
        name:  "users",
        component: SystemUsers,
      },
      {
        path:  "view_admin/:user_id",
        name:  "view_admin",
        component: ViewAdmin,
      },

      {
        path: "view_assets/",
        name: "view_assets",
        component: ViewAssets,
      },
      {
        path: "/assets/view_single_asset/:id",
        name: "view_single_asset",
        component: ViewSingleAsset,
      },
      {
        path:  "view_client/:user_id",
        name:  "view_client",
        component: ViewClient,
      },
      {
        path:  "view_pending_application/:user_id",
        name:  "view_pending_application",
        component: ViewPendingApplication,
      },
      {
        path:  "view_approved_application/:user_id",
        name:  "view_approved_application",
        component: ViewApprovedApplication,
      },
      {
        path:  "view_declined_application/:user_id",
        name:  "view_declined_application",
        component: ViewDeclinedApplication,
      },
      {
        path:  "view_deactivated_application/:user_id",
        name:  "view_deactivated_application",
        component: ViewDeactivatedApplication,
      },
      {
        path:  "view_customer/:user_id",
        name:  "view_customer",
        component: ViewCustomer,
      },
      {
        path:  "view_client_admin/:user_id",
        name:  "view_client_admin",
        component: ViewClientAdmin,
      },
      {
        path:  "service_applications",
        name:  "service_applications",
        component: ServiceApplications,
      },
      {
        path: "logs/",
        name: "view_logs",
        component: ViewLogs,
      },
      {
        path: "view_requested_services/",
        name: "view_requested_services",
        component: ClientRequestedServices,
      },
      {
        path:  "workflow_notifications/:workflow_id",
        name:  "workflow_notifications",
        component: WorkflowNotifications,
      },
    ],
  },
  {
    path: "/client",
    component: ClientDashboard,
    children: [
      {
        path:  "project_table",
        name:  "project_table",
        component: ProjectTable,
      },
      {
        path: "project_dashboard/",
        name: "project_dashboard",
        component: ProjectDashboard,
      },
      {
        path: 'workflow_templates/',
        name: 'workflow_templates',
        component: WorkflowTemplates
      },
      {
        path: 'workflow_templates/',
        name: 'workflow_templates',
        component: WorkflowTemplates
      },
      {
        path: "behalf_application/:workflowId",
        name: "behalf_application",
        component: BehalfApplication,
        props: true,
      },
      {
        path: "batch_processing/:workflow_id",
        name: "batch_processing",
        component: BatchProcessing,
        props: true,
      },
      {
        path: "view_batches/:workflow_id",
        name: "view_batches",
        component: ViewBatches,
        props: true,
      },
      {
        path: "question_management/",
        name: "question_management",
        component: QuestionManagement,
      },
      {
        path: "/conditional_questions/:question_id",
        name: "conditional_questions",
        component: ConditionalQuestions,
      },
      {
        path: "form_management/",
        name: "form_management",
        component: FormManagement,
      },
      {
        path: "manage_form/",
        name: "manage_form",
        component: ManageForm,
      },
      {
        path: "template_management/",
        name: "template_management",
        component: TemplateManagement,
      },
      {
        path: "template_configuration/:template_id",
        name: "template_configuration",
        component: TemplateConfiguration,
      },
      {
        path: "service_dashboard/",
        name: "service_dashboard",
        component: ServiceDashboard,
        props: true,
      },
      {
        path: "edit_workflow/",
        name: "edit_workflow",
        component: WorkflowManagementComponent,
        props: true,
      },
      {
        path: "data_hub/:clientAdminId?",
        name: "data_hub",
        component: DataHub,
        props: true,
      },
      {
        path: "client_admins/",
        name: "client_admins",
        component: ClientAdmins,
        props: true,
      },
      {
        path: "workflow_router/",
        name: "workflow_router",
        component: SubWorkflow,
        props: true,
      },
      {
        path: "thank_you_builder/:workflow_id?",
        name: "thank_you_builder",
        component: ClientThankYou,
        props: true,
      },
      {
        path: "thank_you_configuration/",
        name: "thank_you_configuration",
        component: ThankYouConfiguration,
        props: true,
      },
      {
        path: "view_workflow/",
        name: "client_view_workflow",
        component: ViewWorkflow,
        props: true,
      },

      {
        path: "workflow_services/",
        name: "workflow_services",
        component: WorkflowServices,
      },

      {
        path: "service_rules/:service_id",
        name: "service_rules",
        component: ServiceRules,
      },
      {
        path: "register_question_selection/:service_id",
        name: "register_question_selection",
        component: RegisterQuestionSelection,
      },
      {
        path: "client_services/",
        name: "client_services",
        component: ClientServices,
      },
      {
        path: "arrange_workflow/",
        name: "arrange_workflow",
        component: ArrangeWorkflow,
      },
      {
        path: "client_admin/",
        name: "client_admin",
        component: ClientAdmin,
      },
      {
        path: "reasons_for_usage/",
        name: "reasons_for_usage",
        component: ReasonsForUsage,
      },
      {
        path: "upload_consent/",
        name: "upload_consent",
        component: UploadConsent,
      },
      {
        path: "confirm_workflow/",
        name: "confirm_workflow",
        component: ConfirmWorkflow,
      },
      {
        path: "workflow_dashboard/",
        name: "workflow_dashboard",
        component: WorkflowDashboard,
      },
      {
        path:  "view_customer/:user_id",
        name:  "view_customer",
        component: ViewCustomer,
      },
      {
        path: "view_customers/",
        name: "view_customers",
        component: ViewCustomers,
      },
      {
        path: "view_service/:id",
        name: "view_service",
        component: ViewService,
      },
      {
        path: "instant_verify/",
        name: "instant_verify",
        component: InstantVerify,
      },
      {
        path: "instant_services/",
        name: "instant_services",
        component: InstantServices,
      },
      {
        path: "service_extracts/",
        name: "service_extracts",
        component: ServiceExtracts,
      },
      {
        path: "services/",
        name: "services",
        component: YourServices,
      },
      {
        path: 'toolbox/',
        name: 'toolbox',
        component: ToolBox
      },
      {
        path: 'workbench/',
        name: 'workbench',
        component: WorkbenchComponent
      },
      {
        path: 'utilize_service/:service_id',
        name: 'utilize_service',
        component: ServiceUtilize
      },
      {
        path: "logs/",
        name: "verify_logs",
        component: VerifyLogs,
      },
      {
        path: "customer_data/:id/:application",
        name: "customer_data",
        component: CustomerData,
      },
      {
        path: "customer_applications/:id",
        name: "customer_applications",
        component: CustomerApplications,
      },
      {
        path: "create_asset",
        name: "create_asset",
        component: CreateAsset,
      },
      {
        path: "/view_asset/:id",
        name: "view_asset",
        component: ViewAsset,
      },
      {
        path: "system_communications/",
        name: "system_communications",
        component: SystemCommunications,
      },
      {
        path: 'select_services',
        name: 'select_services',
        component: SelectServices,
      },
    ],
  },
  {
    path: "/",
    component: CustomerIndex,
    children: [
      {
        path: "customer_consent",
        name: "customer_consent",
        component: CustomerConsent,
      },
    ],
  },
  {
    path: "/",
    component: CustomerDashboard,
    meta: { requiresAuth: true },
    children: [
      {
        path: "assigned_workflows",
        name: "assigned_workflows",
        component: AssignedWorkflows,
      },
      {
        path: "customer_profile",
        name: "customer_profile",
        component: CustomerProfile,
      },
    ],
  },
  {
    path: "/thank_you_page",
    name: "thank_you_page",
    component: ThankYouPage,
  },
  {
    path: "/thank_you_page_anonymous",
    name: "thank_you_page_anonymous",
    component: ThankYouAnonymous,
  },
  {
    path: "/thank_you/:workflow_id?",
    name: "thank_you",
    component: ClientThankYou,
    props: true,
  },
  {
    path: "/landing_page",
    name: "landing_page",
    component: DynamicLandingPage,
  },
  {
    path: "/verify_landing_page",
    name: "verify_landing_page",
    component: DynamicLandingPage,
  },
  {
    path: '/notes',
    name: 'notes',
    component: NotesPage,
  },
  {
    path: '/service',
    component: ServiceIndex,
    children: [
      {
        path: "anti_money_laundering",
        name: "anti_money_laundering",
        component: AntiMoneyLaundering,
      },
      {
        path: "refugee_verification",
        name: "refugee_verification",
        component: RefugeeVerification,
      },
      {
        path: "company_verification_pdf",
        name: "company_verification_pdf",
        component: CompanyVerificationPdf,
      },
      {
        path: "qualification_check",
        name: "qualification_check",
        component: QualificationCheck,
      },
      {
        path: "afis_criminal_check",
        name: "afis_criminal_check",
        component: AfisCriminalCheck,
      },
      {
        path: "address_match",
        name: "address_match",
        component: AddressMatch,
      },
      {
        path: "rsa_id_verification",
        name: "rsa_id_verify",
        component: RsaIdVerify,
      },
    ],
  },
  {
    path: "/director_info",
    name: "director_info",
    component: DirectorInfo,
  },
  {
    path: "/upload_proof_of_address",
    name: "upload_proof_of_address",
    component: UploadProofOfAddress,
  },
  {
    path: "/eligibility_service_verification",
    name: "eligibility_service_verification",
    component: EligibilityService,
  },
  {
    path: "/facial_liveness_check_verification",
    name: "facial_liveness_check_verification",
    component: FacialLivenessCheckVerification,
  },
  {
    path: "/online_proof_of_income_verification",
    name: "online_proof_of_income_verification",
    component: ProofOfIncomeOnline,
  },
  {
    path: "/manual_proof_of_income_verification",
    name: "manual_proof_of_income_verification",
    component: ProofOfIncomeManual,
  },
  {
    path: "/rsa_id_verification",
    name: "rsa_id_verification",
    component: RsaIdVerification,
  },
  {
    path: "/search_fcra_verification",
    name: "search_fcra_verification",
    component: SearchFcra,
  },
  {
    path: "/refugee_liveness_verification",
    name: "refugee_liveness_verification",
    component: RefugeeLivenessVerification,
  },
  {
    path: "/rsa_id_liveness_verification",
    name: "rsa_id_liveness_verification",
    component: RsaIdLivenessVerification,
  },
  {
    path: "/alternative_liveness_verification",
    name: "alternative_liveness_verification",
    component: AlternativeLivenessVerification,
  },
  {
    path: "/ocr_liveness_verification",
    name: "ocr_liveness_verification",
    component: OcrLivenessVerification,
  },
  {
    path: "/comprehensive_liveness_verification",
    name: "comprehensive_liveness_verification",
    component: ComprehensiveLivenessVerification,
  },
  {
    path: "/all_in_one_bank_statement_verification",
    name: "all_in_one_bank_statement_verification",
    component: AllInOneBankStatementVerification,
  },
  {
    path: "/complete_retrieval_bank_statement",
    name: "complete_retrieval_bank_statement",
    component: AllInOneComplete,
  },
  {
    path: "/ocr_verification",
    name: "ocr_verification",
    component: OcrVerification,
  },
  {
    path: "/question_based_authentication",
    name: "question_based_authentication",
    component: QuestionBasedAuthentication,
  },
  {
    path: "/facial_biometrics_verification",
    name: "facial_biometrics_verification",
    component: FacialBiometricsVerification,
  },
  {
    path: "/cipc_verification",
    name: "cipc_verification",
    component: CIPCVerification,
  },
  {
    path: "/company_verification_and_score",
    name: "company_verification_and_score",
    component: CompanyVerificationAndScore,
  },
  {
    path: "/aml_verification",
    name: "aml_verification",
    component: AMLVerification,
  },
  {
    path: "/enterprise_aml_verification",
    name: "enterprise_aml_verification",
    component: EnterpriseAMLVerification,
  },
  {
    path: "/enterprise_transunion_credit_verification",
    name: "enterprise_transunion_credit_verification",
    component: EnterpriseTransUnionCreditVerification,
  },
  {
    path: "/enterprise_transunion_kyb_verification",
    name: "enterprise_transunion_kyb_verification",
    component: EnterpriseTransUnionKYBVerification,
  },
  {
    path: "/credit_report",
    name: "id_credit_report",
    component: CreditReport,
  },
  {
    path: "/income_estimator",
    name: "income_estimation_verification",
    component: IncomeEstimator,
  },
  {
    path: "/income_predictor",
    name: "income_predictor_verification",
    component: IncomePredictor,
  },
  {
    path: "/address_match",
    name: "address_match_verification",
    component: AddressMatchVerification,
  },
  {
    path: "/academic_post_92_check",
    name: "academic_post_92_check_verification",
    component: AcademicPost92CheckVerification,
  },
  {
    path: "/custom_service",
    name: "custom_service",
    component: CustomService,
  },
  {
    path: "/entity_data_capture",
    name: "entity_data_capture",
    component: CustomService,
  },
  {
    path: "/bank_account_verification",
    name: "bank_account_verification",
    component: BankAccountVerification,
  },
  {
    path: "/qualification_check",
    name: "qualification_check_verification",
    component: QualCheck,
  },
  {
    path: "/afis_criminal_check",
    name: "afis_criminal_check_verification",
    component: AfisCrimCheck,
  },
  {
    path: "/bank_account_individual_verification",
    name: "bank_account_individual_verification",
    component: BankAccountIndividualVerification,
  },
  {
    path: "/experian_credit_report_verification",
    name: "experian_credit_report_verification",
    component: ExperianCreditReport,
  },
  {
    path: "/online_bank_statement_verification",
    name: "online_bank_statement_verification",
    component: OnlineBankStatement,
  },
  {
    path: "/complete_online_bank_statement/",
    name: "complete_online_bank_statement",
    component: CompleteOnlineBankStatement,
  },
  {
    path: "/manual_bank_statement_verification",
    name: "manual_bank_statement_verification",
    component: ManualBankStatement,
  },

  {
    path: "/employee_screening_service",
    name: "employee_screening_service",
    component: EmployeeScreeningService,
  },

  {
    path: "/address_details",
    name: "address_details",
    component: AddressDetails,
  },
  {
    path: "/qualifying_criteria",
    name: "qualifying_criteria",
    component: QualifyingCriteria,
  },
  {
    path: "/employment_details",
    name: "employment_details",
    component: EmploymentDetails,
  },
  {
    path: "/marital_information",
    name: "marital_information",
    component: MaritalInformation,
  },
  {
    path: "/personal_details",
    name: "personal_details",
    component: PersonalDetails,
  },

  {
    path: "/on_behalf_onboarding",
    name: "on_behalf_onboarding",
    component: OnBehalfOnboarding,
  },

  {
    path: "/sub_workflow_page",
    name:"sub_workflow_page",
    component: SubWorkflowPage,
  },

  {
    path: "/salary_details",
    name: "salary_details",
    component: SalaryDetails,
  },

  {
    path: "/trust_name_search_verification",
    name: "trust_name_search_verification",
    component: TrustNameSearch,
  },

  {
    path: "/refugee_verification",
    name: "refugee_verification",
    component: RefugeeVerificationService,
  },

  {
    path: "/trust_trustees_search_verification",
    name: "trust_trustees_search_verification",
    component: TrustTrusteeSearch,
  },

  {
    path: "/mastercard_match_inquiry",
    name: "mastercard_match_inquiry",
    component: MastercardMatchInquiry,
  },

  {
    path: "/signio_vehicle_finance_application_verification",
    name: "signio_vehicle_finance_application_verification",
    component: SygnioQuestions,
  },
  {
    path: "/trust_search",
    name: "trust_search_verification",
    component: TrustDataFetch,
  },
  {
    path: "/individual_liveness_verification",
    name: "individual_liveness_verification",
    component: IndividualLivenessVerification,
  },
    {
    path: "/telephones",
    name: "telephones_verification",
    component: TelephoneList,
  },
  {
    path: "/sa_criminal_check_verification",
    name: "sa_criminal_check_verification",
    component: HuruCriminalCheckVerification,
  },
  {
    path: "/finance_application",
    name: "seriti_finance_application",
    component: SeritiFinanceApplication,
  },
  {
    path: "/credit_report_namibia",
    name: "credit_report_namibia_verification",
    component: CreditReportNamibia,
  },
  {
    path: "/workflow/:id/:name", // :id and :name are route parameters
    redirect: (to) => {
      const { id, name } = to.params;
      return {
        name: "registration",
        query: { workflow_id: id, workflow_name: name },
      };
    },
  },
  {
    path: "/:customer_application/director_verification",
    redirect: (to) => {
      return {
        name: "landing_page",
        query: {
          customer_application: to.params.customer_application,
        },
      };
    },
  },
  {
    path: "/:embedding_data/",
    redirect: (to) => {
      return {
        name: "landing_page",
        query: {
          embedding_data: to.params.embedding_data,
        },
      };
    },
  },
  {
    path: "/assets/:asset_data/",
    redirect: (to) => {
      return {
        name: "landing_page",
        query: {
          ...to.query,
          asset_data: to.params.asset_data,
        },
      };
    },
  },
  {
    path: "/anonymous_workflow/:anonymous_data",
    redirect: (to) => {
      return {
        name: "landing_page",
        query: {
          anonymous_data: to.params.anonymous_data,
        },
      };
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

/**
 * Clears all modal overlays (Swal and Bootstrap) from the page.
 * Used when redirecting to login after session invalidation.
 */
function clearAllModals() {
  // Close Swal modals
  if (typeof Swal !== 'undefined') {
    Swal.close();
    document.querySelector('.swal2-container')?.remove();
    document.body.classList.remove('swal2-shown', 'swal2-height-auto');
  }
  
  // Close Bootstrap modals
  if (typeof $ !== 'undefined') {
    $('.modal').modal('hide');
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open').css('padding-right', '');
  }
}

/**
 * Clears all authentication data from storage.
 */
function clearAuthData() {
  localStorage.removeItem('token');
  localStorage.removeItem('user_id');
  localStorage.removeItem('user_state');
  sessionStorage.clear();
}

router.beforeEach(async (to, from, next) => {
  // Handle navigation to public pages (login, registration, OTP)
  const publicPages = ['user_login', 'user_registration', 'user_otp'];
  if (publicPages.includes(to.name)) {
    clearAllModals();
    
    // Clear auth data when navigating to login (unless from OTP/password reset flow)
    if (to.name === 'user_login' && from.name !== 'user_otp' && from.name !== 'first_time_password_reset') {
      clearAuthData();
    }
  }
  
  if (from.name) {
    localStorage.setItem("previous_route_name", from.name);
  }
  
  const list_exempt = [
    "user_login",
    "first_time_password_reset",
    "user_otp",
    "user_registration",
    "landing_page",
    "invalid_link",
    "OnboardingIndex",
    "asset_deactive",
    "invalid_token",
    "sygnio_question_verification",
    "thank_you_page_anonymous",
  ];
  
  if (!list_exempt.includes(to.name)) {
    const token = localStorage.getItem("token");
    if (!token) {
      return next({ name: "user_login" });
    }
    return next();
  } else {
    return next();
  }
});

// Intercept fetch requests
const original_fetch = window.fetch;
window.fetch = async function (...args) {
  const requestUrl = args[0]?.url || args[0];

  // Only intercept requests to the API base URL
  if (typeof requestUrl === "string" && requestUrl.startsWith(API_BASE_URL)) {
    const response = await original_fetch.apply(this, args);

    // Handle 401 Unauthorized
    if (response.status === 401) {
      // Clone response to read its JSON while still returning a valid response
      const clonedResponse = response.clone();
      try {
        const data = await clonedResponse.json();
        if (data && data.code === "session_expired") {
          // Session expired, remove token and redirect to login
          localStorage.removeItem("token");
          router.push({ name: "user_login" });
          return response;
        }
        if (data && data.detail === "Invalid token.") {
          // Session expired, remove token and redirect to login
          localStorage.removeItem("token");
          router.push({ name: "user_login" });
          return response;
        }
      } catch (error) {
        const token = localStorage.getItem("token");
        if (token) {
          router.push({ name: "user_otp" });
        } else {
          router.push({ name: "user_login" });
        }
      }

      const token = localStorage.getItem("token");
      if (token) {
        router.push({ name: "user_otp" });
      } else {
        router.push({ name: "user_login" });
      }
    }

    // Handle 403 Forbidden
    if (response.status === 403) {
      // Using toast for permission error
      const { useToast } = await import("@/components/Toast/useToast");
      const { showError } = useToast();
      showError(
        "Permission Denied",
        "You do not have permission to perform this action.",
      );
    }

    return response;
  } else {
    // Pass through for non-API requests
    return original_fetch.apply(this, args);
  }
};

// jQuery AJAX interceptor using global events
if (typeof $ !== "undefined") {
  $(document).ajaxError(function (event, xhr, settings) {
    if (!settings.url?.startsWith(API_BASE_URL)) return;
    
    const isLoginPage = router.currentRoute.value?.name === "user_login";
    const isLoginRequest = settings.url.includes("/api/login/") || settings.url.includes("/get_login_form_api/");
    
    // Skip error handling for login page requests
    if (isLoginPage || isLoginRequest) return;
    
    if (xhr.status === 401) {
      clearAllModals();
      clearAuthData();
      router.push({ name: "user_login" });
    }

    if (xhr.status === 403) {
      import("@/components/Toast/useToast").then(({ useToast }) => {
        useToast().showError("Permission Denied", "You do not have permission to perform this action.");
      });
    }
  });
} else {
  console.warn("jQuery not available for AJAX setup");
}

export default router;
